import { MaintenanceWindowSimpleSchedulerView } from '../view/MaintenanceWindowSimpleSchedulerView';
import { templateMaintenanceWindowSimpleScheduler } from '../view/template';
import { BaseWebComponentController, WebComponentEvent } from '../../../framework/BaseWebComponentController';
import { MaintenanceWindowSimpleSchedulerWebComponent } from '..';
import { MaintenanceWindowSimpleSchedulerSchema } from '../types';
import { RecurrenceOptions } from '../../../types/common/schedulerTypes';
import { FormGroupHelper } from '../../../utils/maintenanceWindow/FormGroupHelper';
import { toggleVisibility } from '../../../utils/htmlElement.utils';

export class MaintenanceWindowSimpleSchedulerController extends BaseWebComponentController {
  public component: MaintenanceWindowSimpleSchedulerWebComponent;
  public view: MaintenanceWindowSimpleSchedulerView;
  public viewConstructor: typeof MaintenanceWindowSimpleSchedulerView;

  constructor(component: MaintenanceWindowSimpleSchedulerWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: MaintenanceWindowSimpleSchedulerView,
      viewTemplate: templateMaintenanceWindowSimpleScheduler,
    });
  }

  public computeEventListeners() {
    return [
      {
        element: this.view.dom.$recurrenceFormField.Input,
        event: 'selectionChanged',
        callback: this.toggleRecurrenceOptions,
      },
      {
        element: this.view.dom.$recurrenceFormField.Input,
        event: 'triggerRevalidation',
        callback: this.restoreSchedulerState,
      },
    ];
  }

  private toggleRecurrenceOptions(ev: WebComponentEvent): void {
    switch (ev.detail.value) {
      case RecurrenceOptions.IMMEDIATELY.toString():
        // hide daily and weekly containers
        this.displayDailyOptions(false);
        this.displayWeeklyOptions(false);
        break;
      case RecurrenceOptions.DAILY.toString():
        // hide weekly container / show daily container
        this.displayDailyOptions(true);
        this.displayWeeklyOptions(false);
        break;
      case RecurrenceOptions.WEEKLY.toString():
        // hide daily container / show weekly container
        this.displayDailyOptions(false);
        this.displayWeeklyOptions(true);
        break;
      default:
        return;
    }
    this.view.formGroup.validate();
  }

  private restoreSchedulerState(): void {
    const recurrenceValue = this.view.dom.$recurrenceFormField.Input.getFormValue();
    this.toggleRecurrenceOptions({ detail: { value: recurrenceValue } } as WebComponentEvent);
  }

  private displayDailyOptions(display: boolean): void {
    toggleVisibility(this.view.dom.$recurrenceDailyOptionsContainer, display);
    FormGroupHelper.setDisabledFormFields(!display, [this.view.dom.$recurrenceDailyAtFormField]);
  }

  private displayWeeklyOptions(display: boolean): void {
    toggleVisibility(this.view.dom.$recurrenceWeeklyOptionsContainer, display);
    FormGroupHelper.setDisabledFormFields(!display, [
      this.view.dom.$recurrenceWeeklyOnDaysFormField,
      this.view.dom.$recurrenceWeeklyAtFormField,
    ]);
  }

  async getDataForView(): Promise<{
    viewData: MaintenanceWindowSimpleSchedulerSchema | null;
    hasImmediatelyOption: boolean;
    disabled: boolean;
  }> {
    return {
      viewData: this.component.viewData,
      disabled: this.component.disabled,
      hasImmediatelyOption: this.component.hasImmediatelyOption,
    };
  }
}
